/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useContext } from 'react';
import { useNavigate, Link } from "react-router";

import { useAuth } from '@/commons/auth';
import { Button, Detail, VisualizationAttr, Modal, Spinner } from '@/commons/components';

import deleteRuangan from '../services/deleteRuangan';

import * as Layouts from "@/commons/layouts";


const DetailRuangan = ({ data }) => {
    const { checkPermission } = useAuth();
    const navigate = useNavigate();
    const [showModalKonfirmasiHapusRuangan, setShowModalKonfirmasiHapusRuangan] = React.useState(false); 
    const ubahRuangan = async () => {
      navigate(
        '/ruangan/ubah?'
        + `id=${data.id}`
        
      );
    };
    
    
  
    const hapus = async () => {
      await deleteRuangan({
        id: data.id,
      });
      navigate('/ruangan');
    };
  
  return (
    <Layouts.DetailComponentLayout
      item={data}
      itemsAttrs={[
        {
          id: "nama",
          condition: "",
          label: "Nama",
          featureName: "nama",
        }
        ,
        {
          id: "kapasitas",
          condition: "",
          label: "Kapasitas",
          featureName: "kapasitas",
        }
        ,
        {
          id: "keterangan",
          condition: "",
          label: "Keterangan",
          featureName: "keterangan",
        }
        
      ]}
      itemsEvents={[
            checkPermission("UpdateRuangan") &&  (
              <Button
                id="_xd5mUCr7EfCz9KF7E6i0TQ"
                variant="secondary"
                onClick={() => ubahRuangan()}
              >
                Ubah Ruangan
              </Button>
            )
        ,
            checkPermission("DeleteRuangan") &&  (
              <Button
                id="_z3iXMCr7EfCz9KF7E6i0TQ"
                variant="tertiary"
                onClick={() => setShowModalKonfirmasiHapusRuangan(true)}
              >
                Hapus
              </Button>
            )
        
      ]}
      itemsModals={[
        <Modal
           isShow={showModalKonfirmasiHapusRuangan}
           title={"Konfirmasi Hapus Ruangan"}
           text={"Are you sure want to proceed?"}
        >
           <Link to=''><Button variant="tertiary" onClick={() => setShowModalKonfirmasiHapusRuangan(false)}>Batal</Button></Link>
          <Button
            id="_OQ20UCr8EfCz9KF7E6i0TQ"
            variant="danger"
            onClick={() => hapus()}
          >
            Hapus
          </Button>
        </Modal>
        
      ]}
    />
  );
};

export default DetailRuangan;
